import {
  pushOptions,
  pullOptions,
} from "../views/coaching-portal/custom-workflows/data/getting-started";

const CustomWorkflows = (app) => {
  app
    .post(
      "/custom-workflows/getting-started/create",
      async ({ res, flash, api, req }) => {
        const access = req.body.access ?? "push";
        const body = {
          type: "getting-started",
          status: "draft",
          access,
          options: access === "push" ? pushOptions : pullOptions,
        };

        await api("workflow", {
          method: "POST",
          body,
        });

        flash("success", "Successfully created");
        res.backDontScroll();
      }
    )
    .get(
      "/custom-workflows/publish/:id",
      async ({ api, assert, res, req, flash }) => {
        const { id } = req.params;
        assert(id, 400, "Workflow ID is required");

        try {
          await api(`workflow/${id}`, {
            method: "PUT",
            body: { status: "published" },
          });
          flash("success", "Successfully published");
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .get(
      "/custom-workflows/unpublish/:id",
      async ({ api, assert, res, req, flash }) => {
        const { id } = req.params;
        assert(id, 400, "Workflow ID is required");

        try {
          await api(`workflow/${id}`, {
            method: "PUT",
            body: { status: "draft" },
          });
          flash("success", "Successfully unpublished");
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    );
};

export default CustomWorkflows;
